
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_main_power",
    extends: UnitInfo__sensors_default,
    computed:{
        value() {
            return this.unitLmsgSensors.main_power?.text;//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__charge' : false
        }
    },
}
</script>

<style scoped>

</style>